import { captureEvent } from '../metrics/captureEvent'

/**
 * Captures submit clicked
 */
export function captureSubmitClick() {
  captureEvent('form-clicked')
}
